import Vue from 'vue';

export default {
    find(parametros) {
        return Vue.axios.get("comida-complemento/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    get(id) {
        return Vue.axios.get("comida-complemento/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    update(parametros) {
        return Vue.axios.put("comida-complemento", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    delete(parametros) {
        return Vue.axios.post("comida-complemento/delete", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    store(parametros) {
        return Vue.axios.post("comida-complemento", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }
}